<template>
    <div>
        <div class="main-content">
            <div class="page-content">
            <div class="container">
                <div class="page-links">
                    <router-link to="/climbing/camps" class="page-links__item">Camps & Heights</router-link>
                    <router-link to="/climbing/distance" class="page-links__item">Distance & Time</router-link>
                    <router-link to="/climbing/temperature" class="page-links__item is-active">Temperature</router-link>
                    <router-link to="/climbing/moon" class="page-links__item">Moon Phases</router-link>
                </div>
				<div class="lds-ring" v-if="!isLoad"><div></div><div></div><div></div><div></div></div>
                <section class="kilimanjaro-table">
              <div class="page-title page-title_select" v-if="isLoad">
                <h2>Average Temperature</h2>
				<div class="form-control-group form-control-group_mounts-2"><span class="form-control-label">Mount</span>
                  <div :class="['select-wrapper select-wrapper', {'is-active' : mountSelect}]" @click="mountSelect = !mountSelect">
                        <div class="select-trigger"><span class="select-trigger__name">{{mountains.find(item => item.active) ? mountains.find(item => item.active).title : ''}}</span><span class="select-trigger__icon">
                            <svg width="1em" height="1em" class="icon icon-chevron ">
                                <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                            </svg></span></div>
                        <div class="select-body">
                            <div class="select-inner js-scrollbar">
                            <div 
                                v-for="item in mountains"
                                :key="item.id"
                                :class="['select-option', { 'is-selected': item.active }]"
                                @click="mountains = mountains.map(mount => ({...mount, active: mount.id === item.id}))"><span class="select-option__name">{{item.title}}</span></div>
                            </div>
                        </div>
                        </div>
                </div>
              </div>
              <form action="javascript:void(0)" class="kilimanjaro-table__form" v-if="isLoad">
                <div data-simplebar="data-simplebar" class="section-table-wrap">
                  <table class="kilimanjaro-table__item kilimanjaro-table__item--temperature">
                    <thead>
                      <tr>
                        <th colspan="2" class="kilimanjaro-table__item__month"><span>Month</span></th>
                        <th><span>2500m</span></th>
                        <th><span>3000m</span></th>
                        <th><span>3500m</span></th>
                        <th><span>4000m</span></th>
                        <th><span>4500m</span></th>
                        <th><span>5000m</span></th>
                        <th><span>5500m</span></th>
                        <th><span>6000m</span></th>
                      </tr>
                    </thead>
                    <tbody v-for="item in temperature" :key="item.month">
                      <tr>
                        <td rowspan="2" class="kilimanjaro-table__item__month"><span>{{item.name}}</span></td>
                        <td class="kilimanjaro-table__item__day">
                          <svg width="1em" height="1em" class="icon icon-daytime ">
                            <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-daytime"></use>
                          </svg><span>Day time</span>
                        </td>
                        <td @click="isEdit = true">
						  <the-mask type="text" v-model="item.heights['2500'].day" :tokens="{'$' : {pattern: /[+-]?/}, '#': {pattern: /[\d]?/, transform: v => v === '°C' || v === 'C' || v === '°' || /[^\d\-\+]/g.test(v) ? '' : v}}" :mask="['#°C', '##°C', '$##°C']"/>
                        </td>
                        <td @click="isEdit = true">
						  <the-mask type="text" v-model="item.heights['3000'].day" :tokens="{'$' : {pattern: /[+-]?/}, '#': {pattern: /[\d]?/, transform: v => v === '°C' || v === 'C' || v === '°' || /[^\d\-\+]/g.test(v) ? '' : v}}" :mask="['#°C', '##°C', '$##°C']"/>
                        </td>
                        <td @click="isEdit = true">
						  <the-mask type="text" v-model="item.heights['3500'].day" :tokens="{'$' : {pattern: /[+-]?/}, '#': {pattern: /[\d]?/, transform: v => v === '°C' || v === 'C' || v === '°' || /[^\d\-\+]/g.test(v) ? '' : v}}" :mask="['#°C', '##°C', '$##°C']"/>
                        </td>
                        <td @click="isEdit = true">
						  <the-mask type="text" v-model="item.heights['4000'].day" :tokens="{'$' : {pattern: /[+-]?/}, '#': {pattern: /[\d]?/, transform: v => v === '°C' || v === 'C' || v === '°' || /[^\d\-\+]/g.test(v) ? '' : v}}" :mask="['#°C', '##°C', '$##°C']"/>
                        </td>
                        <td @click="isEdit = true">
						  <the-mask type="text" v-model="item.heights['4500'].day" :tokens="{'$' : {pattern: /[+-]?/}, '#': {pattern: /[\d]?/, transform: v => v === '°C' || v === 'C' || v === '°' || /[^\d\-\+]/g.test(v) ? '' : v}}" :mask="['#°C', '##°C', '$##°C']"/>
                        </td>
                        <td @click="isEdit = true">
						  <the-mask type="text" v-model="item.heights['5000'].day" :tokens="{'$' : {pattern: /[+-]?/}, '#': {pattern: /[\d]?/, transform: v => v === '°C' || v === 'C' || v === '°' || /[^\d\-\+]/g.test(v) ? '' : v}}" :mask="['#°C', '##°C', '$##°C']"/>
                        </td>
                        <td @click="isEdit = true">
						  <the-mask type="text" v-model="item.heights['5500'].day" :tokens="{'$' : {pattern: /[+-]?/}, '#': {pattern: /[\d]?/, transform: v => v === '°C' || v === 'C' || v === '°' || /[^\d\-\+]/g.test(v) ? '' : v}}" :mask="['#°C', '##°C', '$##°C']"/>
                        </td>
                        <td @click="isEdit = true">
						  <the-mask type="text" v-model="item.heights['6000'].day" :tokens="{'$' : {pattern: /[+-]?/}, '#': {pattern: /[\d]?/, transform: v => v === '°C' || v === 'C' || v === '°' || /[^\d\-\+]/g.test(v) ? '' : v}}" :mask="['#°C', '##°C', '$##°C']"/>
                        </td>
                      </tr>
                      <tr>
                        <td class="kilimanjaro-table__item__day">
                          <svg width="1em" height="1em" class="icon icon-nighttime ">
                            <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-nighttime"></use>
                          </svg><span>Night time</span>
                        </td>
                        <td @click="isEdit = true">
						  	<the-mask type="text" v-model="item.heights['2500'].night" :tokens="{'$' : {pattern: /[+-]?/}, '#': {pattern: /[\d]?/, transform: v => v === '°C' || v === 'C' || v === '°' || /[^\d\-\+]/g.test(v) ? '' : v}}" :mask="['#°C', '##°C', '$##°C']"/>
                        </td>
                        <td @click="isEdit = true">
						  <the-mask type="text" v-model="item.heights['3000'].night" :tokens="{'$' : {pattern: /[+-]?/}, '#': {pattern: /[\d]?/, transform: v => v === '°C' || v === 'C' || v === '°' || /[^\d\-\+]/g.test(v) ? '' : v}}" :mask="['#°C', '##°C', '$##°C']"/>
                        </td>
                        <td @click="isEdit = true">
						  <the-mask type="text" v-model="item.heights['3500'].night" :tokens="{'$' : {pattern: /[+-]?/}, '#': {pattern: /[\d]?/, transform: v => v === '°C' || v === 'C' || v === '°' || /[^\d\-\+]/g.test(v) ? '' : v}}" :mask="['#°C', '##°C', '$##°C']"/>
                        </td>
                        <td @click="isEdit = true">
						  <the-mask type="text" v-model="item.heights['4000'].night" :tokens="{'$' : {pattern: /[+-]?/}, '#': {pattern: /[\d]?/, transform: v => v === '°C' || v === 'C' || v === '°' || /[^\d\-\+]/g.test(v) ? '' : v}}" :mask="['#°C', '##°C', '$##°C']"/>
                        </td>
                        <td @click="isEdit = true">
						  	<the-mask type="text" v-model="item.heights['4500'].night" :tokens="{'$' : {pattern: /[+-]?/}, '#': {pattern: /[\d]?/, transform: v => v === '°C' || v === 'C' || v === '°' || /[^\d\-\+]/g.test(v) ? '' : v}}" :mask="['#°C', '##°C', '$##°C']"/>
                        </td>
                        <td @click="isEdit = true">
						  	<the-mask type="text" v-model="item.heights['5000'].night" :tokens="{'$' : {pattern: /[+-]?/}, '#': {pattern: /[\d]?/, transform: v => v === '°C' || v === 'C' || v === '°' || /[^\d\-\+]/g.test(v) ? '' : v}}" :mask="['#°C', '##°C', '$##°C']"/>
                        </td>
                        <td @click="isEdit = true">
						  	<the-mask type="text" v-model="item.heights['5500'].night" :tokens="{'$' : {pattern: /[+-]?/}, '#': {pattern: /[\d]?/, transform: v => v === '°C' || v === 'C' || v === '°' || /[^\d\-\+]/g.test(v) ? '' : v}}" :mask="['#°C', '##°C', '$##°C']"/>
                        </td>
                        <td @click="isEdit = true">
						  	<the-mask type="text" v-model="item.heights['6000'].night" :tokens="{'$' : {pattern: /[+-]?/}, '#': {pattern: /[\d]?/, transform: v => v === '°C' || v === 'C' || v === '°' || /[^\d\-\+]/g.test(v) ? '' : v}}" :mask="['#°C', '##°C', '$##°C']"/>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="kilimanjaro-table__form__submit">
                  <button type="button" class="btn btn--green" @click="saveTemperature"><span>Save</span></button>
                </div>
              </form>
            </section>
            </div>
            </div>
        </div>
    </div>
</template>

<script>

    import { 
        getTemperature,
        updateTemperature,
		getMountains
    } from '@/utilites/api'

	import {TheMask} from 'vue-the-mask'

    export default {
        data(){
            return { 
                temperature: [],
				defaultTemperatures: [
					{
						month: 1,
						name: 'January',
						heights: {
							'2500' : {
								day: '',
								night: ''
							},
							'3000' : {
								day: '',
								night: ''
							},
							'3500' : {
								day: '',
								night: ''
							},
							'4000' : {
								day: '',
								night: ''
							},
							'4500' : {
								day: '',
								night: ''
							},
							'5000' : {
								day: '',
								night: ''
							},
							'5500' : {
								day: '',
								night: ''
							},
							'6000' : {
								day: '',
								night: ''
							},
						}
					},
					{
						month: 2,
						name: 'February',
						heights: {
							'2500' : {
								day: '',
								night: ''
							},
							'3000' : {
								day: '',
								night: ''
							},
							'3500' : {
								day: '',
								night: ''
							},
							'4000' : {
								day: '',
								night: ''
							},
							'4500' : {
								day: '',
								night: ''
							},
							'5000' : {
								day: '',
								night: ''
							},
							'5500' : {
								day: '',
								night: ''
							},
							'6000' : {
								day: '',
								night: ''
							},
						}
					},
					{
						month: 3,
						name: 'March',
						heights: {
							'2500' : {
								day: '',
								night: ''
							},
							'3000' : {
								day: '',
								night: ''
							},
							'3500' : {
								day: '',
								night: ''
							},
							'4000' : {
								day: '',
								night: ''
							},
							'4500' : {
								day: '',
								night: ''
							},
							'5000' : {
								day: '',
								night: ''
							},
							'5500' : {
								day: '',
								night: ''
							},
							'6000' : {
								day: '',
								night: ''
							},
						}
					},
					{
						month: 4,
						name: 'April',
						heights: {
							'2500' : {
								day: '',
								night: ''
							},
							'3000' : {
								day: '',
								night: ''
							},
							'3500' : {
								day: '',
								night: ''
							},
							'4000' : {
								day: '',
								night: ''
							},
							'4500' : {
								day: '',
								night: ''
							},
							'5000' : {
								day: '',
								night: ''
							},
							'5500' : {
								day: '',
								night: ''
							},
							'6000' : {
								day: '',
								night: ''
							},
						}
					},
					{
						month: 5,
						name: 'May',
						heights: {
							'2500' : {
								day: '',
								night: ''
							},
							'3000' : {
								day: '',
								night: ''
							},
							'3500' : {
								day: '',
								night: ''
							},
							'4000' : {
								day: '',
								night: ''
							},
							'4500' : {
								day: '',
								night: ''
							},
							'5000' : {
								day: '',
								night: ''
							},
							'5500' : {
								day: '',
								night: ''
							},
							'6000' : {
								day: '',
								night: ''
							},
						}
					},
					{
						month: 6,
						name: 'June',
						heights: {
							'2500' : {
								day: '',
								night: ''
							},
							'3000' : {
								day: '',
								night: ''
							},
							'3500' : {
								day: '',
								night: ''
							},
							'4000' : {
								day: '',
								night: ''
							},
							'4500' : {
								day: '',
								night: ''
							},
							'5000' : {
								day: '',
								night: ''
							},
							'5500' : {
								day: '',
								night: ''
							},
							'6000' : {
								day: '',
								night: ''
							},
						}
					},
					{
						month: 7,
						name: 'July',
						heights: {
							'2500' : {
								day: '',
								night: ''
							},
							'3000' : {
								day: '',
								night: ''
							},
							'3500' : {
								day: '',
								night: ''
							},
							'4000' : {
								day: '',
								night: ''
							},
							'4500' : {
								day: '',
								night: ''
							},
							'5000' : {
								day: '',
								night: ''
							},
							'5500' : {
								day: '',
								night: ''
							},
							'6000' : {
								day: '',
								night: ''
							},
						}
					},
					{
						month: 8,
						name: 'August',
						heights: {
							'2500' : {
								day: '',
								night: ''
							},
							'3000' : {
								day: '',
								night: ''
							},
							'3500' : {
								day: '',
								night: ''
							},
							'4000' : {
								day: '',
								night: ''
							},
							'4500' : {
								day: '',
								night: ''
							},
							'5000' : {
								day: '',
								night: ''
							},
							'5500' : {
								day: '',
								night: ''
							},
							'6000' : {
								day: '',
								night: ''
							},
						}
					},
					{
						month: 9,
						name: 'September',
						heights: {
							'2500' : {
								day: '',
								night: ''
							},
							'3000' : {
								day: '',
								night: ''
							},
							'3500' : {
								day: '',
								night: ''
							},
							'4000' : {
								day: '',
								night: ''
							},
							'4500' : {
								day: '',
								night: ''
							},
							'5000' : {
								day: '',
								night: ''
							},
							'5500' : {
								day: '',
								night: ''
							},
							'6000' : {
								day: '',
								night: ''
							},
						}
					},
					{
						month: 10,
						name: 'October',
						heights: {
							'2500' : {
								day: '',
								night: ''
							},
							'3000' : {
								day: '',
								night: ''
							},
							'3500' : {
								day: '',
								night: ''
							},
							'4000' : {
								day: '',
								night: ''
							},
							'4500' : {
								day: '',
								night: ''
							},
							'5000' : {
								day: '',
								night: ''
							},
							'5500' : {
								day: '',
								night: ''
							},
							'6000' : {
								day: '',
								night: ''
							},
						}
					},
					{
						month: 11,
						name: 'November',
						heights: {
							'2500' : {
								day: '',
								night: ''
							},
							'3000' : {
								day: '',
								night: ''
							},
							'3500' : {
								day: '',
								night: ''
							},
							'4000' : {
								day: '',
								night: ''
							},
							'4500' : {
								day: '',
								night: ''
							},
							'5000' : {
								day: '',
								night: ''
							},
							'5500' : {
								day: '',
								night: ''
							},
							'6000' : {
								day: '',
								night: ''
							},
						}
					},
					{
						month: 12,
						name: 'December',
						heights: {
							'2500' : {
								day: '',
								night: ''
							},
							'3000' : {
								day: '',
								night: ''
							},
							'3500' : {
								day: '',
								night: ''
							},
							'4000' : {
								day: '',
								night: ''
							},
							'4500' : {
								day: '',
								night: ''
							},
							'5000' : {
								day: '',
								night: ''
							},
							'5500' : {
								day: '',
								night: ''
							},
							'6000' : {
								day: '',
								night: ''
							},
						}
					}
				],
				mountains: [],
                mountSelect: false,
				isLoad: false,
				isEdit: false
            }
        },
		beforeRouteLeave(to, from, next){
			if(this.isEdit){
				this.$emit('notLeaveHandler')
			}
			next()
		},
		components: {TheMask},
        props: ['user'],
		 beforeCreate(){
           document.title = 'Climbing / Temperature'
        },
        mounted(){
            document.title = 'Climbing / Temperature'
			this.temperature = this.defaultTemperature
			this.isLoad = false
			getMountains(this.user.access_token)
            .then(res => {
                this.mountains = res.map((item, index) => ({...item, active: index === 0}))
            })
			window.addEventListener('click', event => {
                if(!event.target.closest('.select-wrapper')){
                    this.mountSelect = false
                }
            })
        },
        methods: {
            updateData(id){
                getTemperature(this.user.access_token, id)
                .then(res => {
                    this.temperature = res.data
					this.isLoad = true
                })
				.catch(() => {
					this.temperature = this.defaultTemperatures
					this.isLoad = true
				})
            },
            saveTemperature(){
                updateTemperature(this.user.access_token, {
                    data: this.temperature
                }, this.mountains.find(item => item.active).id)
                .then(() => {
					this.$emit('confirmed')
					this.updateData(this.mountains.find(item => item.active).id)
					this.isEdit = false
				})
				.catch(() => {
					this.temperature = this.defaultTemperatures
				})
            }
        },
        watch: {
            mountains(){
				this.isLoad = false
                let id = this.mountains.find(item => item.active).id
                this.updateData(id)
            },
        }
    }

</script>